export default __webpack_public_path__ + "static/media/picto-score.4262b0a1.svg";